import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React from 'react';
import {SingleSource,WorkItems} from '../utility';
import WorkFooter from '../components/workfooter';
import Context from '../components/context';

export default function WorkPage() {
    const workItem = WorkItems();

    return (
        <>
            <Container className='pt-5 mt-5 work'>
                <div className='subTitle text-start'>AI-Powered Document Repository</div>
                <div className="d-flex align-items-center py-3">
                    <h1 className='mainTitle text-start'>{workItem.title}</h1>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/title.jpg`}/>
                </div>
                <Row className="d-flex align-items-center">
                    <Col lg='1'>
                        <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/summary.jpg`}/>
                    </Col>
                    <Col>
                        <div className='mainDes text-start'>
                            The USDA's Field Office Technical Guide (FOTG) is the primary reference for conservation practices nationwide.
                            <span className='workBold'> This project began as a mobile-first redesign and expanded with AI-powered enhancements.</span>
                        </div>
                    </Col>
                </Row>
                <div className="d-flex align-items-center py-3">                   
                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/finger.jpg`}/>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <div className='text-start'>
                        Check product at <a href='https://efotg.sc.egov.usda.gov/#/'>https://efotg.sc.egov.usda.gov/#/</a>.
                    </div>
                </div>
                <Row className='pt-5 text-start'>
                    <Col lg sm='12' className='py-3'>
                        <div className='workBold2'>
                            Client
                        </div>
                        <div>
                            USDA 
                        </div>
                    </Col>
                    <Col lg sm='12' className='py-3'>
                        <div className='workBold2'>
                            Role
                        </div>
                        <div>
                            Lead UX Designer
                        </div>
                    </Col>
                    <Col lg sm='12' className='py-3'>
                        <div className='workBold2'>
                            Time
                        </div>
                        <div>
                            Phase I: 10.2022 - 03.2023
                            <br></br>
                            Phase II: 03.2025 - 06.2025
                        </div>
                    </Col>
                    <Col lg sm='12' className='py-3'>
                        <div className='workBold2'>
                            Team
                        </div>
                        <div>
                            An agile team of 12
                        </div>
                    </Col>
                </Row>
            </Container>
            <section id="section-2">
                <Container>
                    <Container className='work'>
                        <Row>
                            <Col lg xs='12'>
                                <video width="100%" autoPlay muted playsInline>
                                    <source src={`/img/${workItem.assets.toLocaleLowerCase()}/1.mp4`} type="video/mp4" />
                                </video>
                            </Col>
                            <Col lg xs='12'>
                                <video width="100%" autoPlay muted playsInline>
                                    <source src={`/img/${workItem.assets.toLocaleLowerCase()}/2.mp4`} type="video/mp4" />
                                </video>
                            </Col>
                            <Col lg xs='12'>
                                <video width="100%" autoPlay muted playsInline>
                                    <source src={`/img/${workItem.assets.toLocaleLowerCase()}/3.mp4`} type="video/mp4" />
                                </video>
                            </Col>
                        </Row>
                        <Row className='pt-5'>
                            <Col>
                                <div className='mainTitle'>
                                    37%
                                </div>
                                <div className='mt-3'>
                                    Increase Mobile Usage
                                </div>
                            </Col>
                            <Col>
                                <div className='mainTitle'>
                                    33%
                                </div>
                                <div className='mt-3'>
                                    Decrease Bounce Rate
                                </div>
                            </Col>
                            <Col>
                                <div className='mainTitle'>
                                    21%
                                </div>
                                <div className='mt-3'>
                                    Improved Session Depth
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg6'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row className='text-start py-5' id="problem_statement">
                        <Col className='d-flex align-items-center'>
                            <div>
                                <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/problem.jpg`}/>
                            </div>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <div>
                                <span className='workItalic2'>Problem of the Legacy Tool</span>
                                <ul className='workBold'>
                                    <li>
                                        No mobile support
                                    </li>
                                    <li>
                                        Overly complex taxonomy
                                    </li>
                                    <li>
                                        Limited search functionality
                                    </li>
                                </ul>
                            </div>
                        </Col>
                        <Col>
                           Our goal was to modernize access and usability with a mobile-first redesign and AI-powered features that enhanced search accuracy, speed, and reliability.
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg6'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row className='text-start py-5'>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/research.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2' id="discovery_research">
                                        Discovery Research
                                    </div>
                                    <div className='workBold3'>
                                        Users Struggle with Content Structure
                                    </div>
                                </div>
                            </div>
                            <div className='pt-3'>
                                <SingleSource src={`/img/${workItem.assets.toLocaleLowerCase()}/user1.jpg`} />
                            </div>
                        </Col>
                        <Col className='text-center'>
                            <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/research2.jpg`}/>
                            <div className='text-start py-5 px-5'>
                                Although the tool serves multiple user groups, only Content Viewers accessed it on mobile. Through
                                <span className='workBold'> user interviews </span>and
                                <span className='workBold'> cognitive walkthroughs </span>, we were surprised to learn that their biggest pain point wasn't mobile access, but following content structure!
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg6'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row className='text-start py-5'>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/clap.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2' id="change">
                                        Exceeded Expectation !!!
                                    </div>
                                    <div className='workBold3'>
                                        A Scalable and Flexible Way to Search
                                    </div>
                                </div>
                            </div>
                            <div className='text-start pt-5 pe-5'>
                                The original project scope focused on mobile access, but the deeper pain point—
                                <span className='workBoldColor6'>structure complexity</span>—would still remain. Restructuring the taxonomy was impractical: aligning hundreds of content managers was infeasible; and users often had conflicting mental models of how content should be organized.
                                <br></br>
                                <br></br>
                                I led a 5 Whys analysis and discovered that the root was about document findability. This insight informed the solution:
                                <span className='workBoldColor6'> in-folder search</span>. By allowing users to narrow content to a parent folder rather than searching the entire system, we eliminated the repetitive frustration of state-wide searches. The feature leveraged
                                <span className='workBoldColor6'> Elasticsearch </span> for tolerance of typos and partial queries.
                            </div>
                        </Col>
                        <Col className='text-center'>
                            <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/structure.jpg`}/>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg6'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row className='text-start align-items-center py-5' id="test">
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/test.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2'>
                                        Usability Test
                                    </div>
                                    <div className='workBold3'>
                                        Turning Feedback<br></br>into Confidence
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            I led two rounds of
                            <span className='workBold'> usability testing </span>
                            with distinct user groups to evaluate flow clarity and signifier comprehension, using insights to drive targeted design refinements.
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 my-5 work'>
                    <div className='breaker altbg6'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work py-5'>
                    <Row className='text-start align-items-center' id="mobile">
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/search.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2'>
                                        Phase I
                                    </div>
                                    <div className='workBold3'>
                                        Smarter Search &<br></br>Seamless Mobile Access
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className='pb-3'>
                                For the first milestone, we focused on mobile access and faster document discovery without overhauling the massive IA. Key improvements included:
                            </div>
                            <ul>
                                <li>
                                    Pre- and post-search filters.
                                </li>
                                <li>
                                    Support of multiple search terms.
                                </li>
                                <li>
                                    Elasticsearch for faster, more relevant results.
                                </li>
                            </ul>
                        </Col>
                    </Row>
                    <div className='workItalic2 pt-5'>
                        Final Mobile UI (Core)
                    </div>
                    <div>
                        <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/core.jpg`}/>
                    </div>
                </Container>
            </section>
            <section>
                <Container className='work py-5'>
                    <img alt=''width="100%" src={`/img/${workItem.assets.toLocaleLowerCase()}/breaker.jpg`}/>
                </Container>
            </section>
            <section>
                <Container className='work py-5'>
                    <Row className='text-start align-items-center' id="ai">
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <div className='workItalic2'>
                                        Phase II
                                    </div>
                                    <div className='workBold3'>
                                        Enhancing Document Comprehension with AI
                                    </div>
                                </div>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/ai.jpg`}/>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='text-start align-items-center py-5'>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/clock.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2'>
                                        Problems that Persist
                                    </div>
                                    <ul>
                                        <li className='workBold'>
                                            Uncertain search completeness
                                        </li>
                                        <li className='workBold'>
                                            Excessive reading effort
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className='py-5'>
                                <div>
                                    We introduced RAG-powered 
                                    <span className='workBoldColor6'> AI Widgets </span>
                                    to:
                                </div>
                                <ul>
                                    <li>
                                        Natural language search with summaries.
                                    </li>
                                    <li>
                                        Chatbot for open-ended queries.
                                    </li>
                                </ul>
                            </div>
                        </Col>
                        <Col className='text-center'>
                            <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/folder.jpg`}/>
                        </Col>
                    </Row>
                    <Row className='text-start align-items-center py-5'>
                        <Col>
                            <img alt='' width="90%" src={`/img/${workItem.assets.toLocaleLowerCase()}/desktop_1.jpg`}/>
                        </Col>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <div className='workItalic2'>
                                        Solution
                                    </div>
                                    <div className='workBold'>
                                        Design for Efficiency,<br></br>Refine for Confidence
                                    </div>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/shake.jpg`}/>
                                </div>
                            </div>
                            <div className='py-5'>
                                <div>
                                    We received concerns about “confidently wrong” AI outputs. In response, we refined the experience to emphasize:
                                </div>
                                <ul className='py-5'>
                                    <li>
                                        Clear source surfacing.
                                    </li>
                                    <li>
                                        Trust through citations & quotes.
                                    </li>
                                    <li>
                                        Reliable fallback to relevant docs.
                                    </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                    <Row className='text-start align-items-center'>
                        <Col>
                            <div className='workItalic2'>
                                V1. Search result summary & Chatbot
                            </div>
                            <div>
                                <img alt='' width="90%" src={`/img/${workItem.assets.toLocaleLowerCase()}/desktop_2.jpg`}/>
                            </div>
                        </Col>
                        <Col>
                            <div className='workItalic2'>
                                V2. Resource and Relevant Docs added
                            </div>
                            <div>
                                <img alt='' width="90%" src={`/img/${workItem.assets.toLocaleLowerCase()}/desktop_4.jpg`}/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg6'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row className='text-start py-5'>
                        <Col id="impact">
                          <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/impact.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2'>
                                        Impacts
                                    </div>
                                    <div className='workBold'>
                                        Measured Gains
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div>
                                <div>
                                    The responsive design and smarter search are now live to the public. Since launch, we've observed:
                                </div>
                                <ul className='py-5'>
                                    <li>
                                        <span className='workBoldColor6'>+37% </span>mobile usage.
                                    </li>
                                    <li>
                                        <span className='workBoldColor6'>+21% </span>average session depth.
                                    </li>
                                    <li>
                                        <span className='workBoldColor6'>-33% </span>search page bounce rate.
                                    </li>
                                </ul>
                                <div>
                                    Meanwhile, the AI-powered features have successfully completed UAT, earning positive feedback, aiming for phased rollout.
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pb-5'>
                        <Col>
                            <div className='workItalic2 text-start'>
                                Feedback from post-launch survey
                            </div>
                            <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/impact_2.jpg`} />
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container fluid className='work altbg6 py-5 mt-5'>
                    <Container className='altbg6Font work'>
                        <Row className='text-start align-items-center py-5'>
                            <Col>
                                <div className='d-flex align-items-center'>
                                    <div>
                                        <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/think.png`}/>
                                    </div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div>
                                        <div className='workItalic' id="conclusion">
                                            What I Learned
                                        </div>
                                        <div className='workBold3'>
                                            Balancing long-term vision<br></br>with short-term wins
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div>
                                    This project required a holistic approach—meeting user needs without overhauling entrenched systems. Key lessons:
                                </div>
                                <div className='py-5'>
                                    <span className='workBold'>Constraints as strategy</span>: Lightweight solutions targeting root pain points still deliver major impact.
                                </div>
                                <div>
                                    <span className='workBold'>Timely validation</span>: Iterative testing and cross-team collaboration kept designs aligned with user goals and stakeholder confidence.
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </section>
            <Container className='work workFooter'>
                <WorkFooter workPrevious={workItem.workPrevious} workPreviousTitle={workItem.workPreviousTitle} workNext={workItem.workNext} workNextTitle={workItem.workNextTitle} />
            </Container>
            <Context workPrevious={workItem.workPrevious} workNext={workItem.workNext} contextItems={workItem.contextItems} />
        </>
    );
  }